/**
 * Cabeçalho da aplicação: marca MakePub e acesso às configurações.
 */
import { ENV_LABEL } from "../config/env";
import { Button } from "./Button";
import { SettingsIcon } from "./Icons";

interface HeaderProps {
  readonly onOpenSettings: () => void;
  readonly settingsDisabled?: boolean;
}

export function Header({ onOpenSettings, settingsDisabled = false }: HeaderProps) {
  return (
    <header className="mp-header">
      <div className="mp-brand">
        <span className="mp-brand__mark" aria-hidden="true">
          <svg width="26" height="26" viewBox="0 0 64 64" fill="none">
            <path
              d="M18 16h16a10 10 0 0 1 10 10v22a8 8 0 0 0-8-8H18z"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span>MakePub</span>
        {ENV_LABEL ? <span className="mp-brand__env">{ENV_LABEL}</span> : null}
      </div>
      <Button variant="ghost" onClick={onOpenSettings} disabled={settingsDisabled}>
        <SettingsIcon size={18} /> Configurações
      </Button>
    </header>
  );
}
